export function slider(ctx) {
    return {
        styles: {
            // track (bar_bg style) — no border set by firmware at all (border_width: 0 is
            // correct); border_color removed, it was an inert literal ('black') with
            // border_width already 0, no firmware value to match either.
            main:      { bg_color: ctx.COLOR_BG_SEC, bg_opa: 255, radius: 999, border_width: 0 },
            // indicator (bar_indic style) — border_width: 0 added: firmware's bar_indic sets no
            // border at all, but the schema's own default (HASP-theme number) is border_width:2,
            // which would otherwise leak through unmasked for this Material-styled theme.
            indicator: { bg_color: ctx.primary, radius: 999, border_width: 0 },
            // knob (slider_knob) — border_width: 0 added, same reasoning as indicator (schema
            // default border_width:2 would otherwise leak through; slider_knob sets no border).
            knob:      { bg_color: '#ffffff', radius: 999, border_width: 0 },
        },
    };
}
